var _g, _path, _mask, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 77.223 105.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#272727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.389 105.38v-10.407h2.378v1.735h0.109c0.189-0.601 0.514-1.064 0.975-1.389 0.465-0.33 0.996-0.495 1.592-0.495 0.136 0 0.287 7e-3 0.454 0.021 0.172 9e-3 0.314 0.024 0.427 0.047v2.256c-0.104-0.036-0.269-0.068-0.495-0.095-0.221-0.031-0.435-0.047-0.643-0.047-0.447 0-0.849 0.097-1.206 0.291-0.352 0.19-0.63 0.454-0.833 0.793-0.204 0.339-0.305 0.729-0.305 1.172v6.118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.024 105.59c-1.0433 0-1.9444-0.217-2.7032-0.65-0.7543-0.438-1.3347-1.057-1.7412-1.857-0.4065-0.804-0.6097-1.75-0.6097-2.838 0-1.071 0.2032-2.01 0.6097-2.819 0.411-0.813 0.9847-1.445 1.7209-1.897 0.7362-0.456 1.6011-0.684 2.5948-0.684 0.6414 0 1.2466 0.104 1.8157 0.312 0.5736 0.203 1.0795 0.519 1.5176 0.948 0.4427 0.429 0.7904 0.976 1.0434 1.64 0.2529 0.659 0.3794 1.445 0.3794 2.357v0.752h-8.5298v-1.653h6.1788c-0.0045-0.469-0.1061-0.887-0.3048-1.253-0.1988-0.371-0.4765-0.662-0.8334-0.874-0.3523-0.212-0.7633-0.319-1.233-0.319-0.5014 0-0.9417 0.122-1.3211 0.366-0.3794 0.24-0.6753 0.556-0.8876 0.949-0.2077 0.388-0.3139 0.815-0.3184 1.28v1.443c0 0.606 0.1107 1.125 0.332 1.559 0.2213 0.429 0.5307 0.758 0.9282 0.989 0.3974 0.226 0.8626 0.339 1.3956 0.339 0.3568 0 0.6798-0.05 0.9688-0.15 0.2891-0.103 0.5398-0.255 0.7521-0.453 0.2122-0.199 0.3726-0.445 0.481-0.739l2.2899 0.258c-0.1445 0.605-0.42 1.133-0.8265 1.585-0.402 0.447-0.9169 0.795-1.5447 1.043-0.6278 0.244-1.346 0.366-2.1545 0.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.412 94.979-3.706 10.406h-2.71l-3.7059-10.406h2.6152l2.3915 7.73h0.1084l2.3984-7.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.932 91.51v13.875h-2.4525v-13.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.842 105.38v-10.406h2.4525v10.406zm1.233-11.883c-0.3884 0-0.7226-0.129-1.0027-0.387-0.28-0.262-0.42-0.575-0.42-0.941 0-0.371 0.14-0.685 0.42-0.942 0.2801-0.262 0.6143-0.393 1.0027-0.393 0.393 0 0.7272 0.131 1.0027 0.393 0.2801 0.257 0.4201 0.571 0.4201 0.942 0 0.366-0.14 0.679-0.4201 0.941-0.2755 0.258-0.6097 0.387-1.0027 0.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.438 95.324c-0.0633-0.591-0.3297-1.052-0.7995-1.382-0.4652-0.329-1.0704-0.494-1.8157-0.494-0.5239 0-0.9733 0.079-1.3482 0.237s-0.6617 0.373-0.8604 0.644c-0.1988 0.271-0.3004 0.58-0.3049 0.928 0 0.289 0.0655 0.539 0.1965 0.752 0.1355 0.212 0.3184 0.393 0.5487 0.542 0.2304 0.144 0.4856 0.266 0.7656 0.366 0.2801 0.099 0.5624 0.183 0.8469 0.25l1.3008 0.325c0.5239 0.122 1.0275 0.287 1.5108 0.495 0.4878 0.208 0.9237 0.47 1.3076 0.786 0.3884 0.316 0.6956 0.698 0.9214 1.145s0.3388 0.971 0.3388 1.572c0 0.813-0.2078 1.529-0.6233 2.147-0.4156 0.615-1.0163 1.096-1.8022 1.443-0.7814 0.344-1.7276 0.515-2.8387 0.515-1.0795 0-2.0167-0.167-2.8117-0.501-0.7904-0.334-1.4092-0.822-1.8563-1.463-0.4426-0.642-0.682-1.423-0.7182-2.345h2.4729c0.0361 0.484 0.1852 0.886 0.4472 1.206 0.2619 0.321 0.6029 0.56 1.023 0.719 0.4246 0.158 0.8988 0.237 1.4227 0.237 0.5466 0 1.0253-0.082 1.4364-0.244 0.4155-0.167 0.7407-0.398 0.9756-0.691 0.2348-0.298 0.3545-0.646 0.359-1.044-0.0045-0.361-0.1106-0.659-0.3184-0.894-0.2078-0.239-0.4991-0.438-0.874-0.596-0.3703-0.163-0.8039-0.307-1.3008-0.434l-1.5786-0.406c-1.1427-0.294-2.046-0.739-2.71-1.335-0.6594-0.601-0.9891-1.398-0.9891-2.391 0-0.818 0.2213-1.534 0.6639-2.148 0.4472-0.614 1.0547-1.091 1.8225-1.43 0.7679-0.343 1.6373-0.515 2.6084-0.515 0.9846 0 1.8473 0.172 2.5881 0.515 0.7452 0.339 1.3301 0.811 1.7547 1.416 0.4246 0.601 0.6436 1.292 0.6572 2.073z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m77.223 38.611c0 21.324-17.287 38.611-38.611 38.611-21.324 0-38.611-17.287-38.611-38.611 0-21.324 17.287-38.611 38.611-38.611 21.324 0 38.611 17.287 38.611 38.611z",
    fill: "url(#paint0_linear_1699_3704)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_3704",
    x: 56,
    y: 28,
    width: 56,
    height: 56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.46 55.694c0 15.106-12.246 27.352-27.352 27.352-15.106 0-27.352-12.246-27.352-27.352s12.246-27.352 27.352-27.352c15.106 0 27.352 12.246 27.352 27.352z",
    fill: "#c28b37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.21 -14.537)",
    mask: "url(#mask0_1699_3704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.01 52.778c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352c0-15.106 12.246-27.352 27.352-27.352s27.352 12.246 27.352 27.352z",
    fill: "url(#paint1_linear_1699_3704)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.628 18.289 6.4352 12.87 12.87 1.6088-8.8378 9.9102 2.4025 14.222-12.87-6.4352-12.87 6.4352 2.4239-14.222-8.8591-9.9102 12.87-1.6088z",
    fill: "url(#paint2_linear_1699_3704)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.628 16.256 7.0303 14.061 14.105 1.7632-9.6985 10.876 2.6278 15.555-14.064-7.0321-14.067 7.0336 2.6515-15.557-9.7223-10.876 14.108-1.7635zm-6.4352 14.902-12.87 1.6088 8.8591 9.9102-2.4239 14.222 12.87-6.4352 12.87 6.4352-2.4025-14.222 8.838-9.9102-12.871-1.6088-6.4352-12.87z",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_3704",
    x1: 82.822,
    x2: 82.822,
    y1: 14.537,
    y2: 91.759,
    gradientTransform: "translate(-44.21 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aaa",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_3704",
    x1: 82.656,
    x2: 82.656,
    y1: 25.426,
    y2: 80.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_3704",
    x1: 83.838,
    x2: 83.838,
    y1: 45.233,
    y2: 69.794,
    gradientTransform: "translate(-44.21 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE1E1",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardSilver);
export default __webpack_public_path__ + "static/media/reward-silver.f3743653ec55a64333e07270168219b2.svg";
export { ForwardRef as ReactComponent };